class Career {
	async getAllEmployee(companyId) {
		const response = await fetch(`${process.env.REACT_APP_API}/career/company/${companyId}`, {
			method: 'GET',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return await response.json()
	}

	async updateCareer(id, career) {
		const response = await fetch(`${process.env.REACT_APP_API}/career/${id}`, {
			method: 'PUT',
			headers: {
				'Content-type': 'application/json',
			},
			body: JSON.stringify(career),
		})

		return await response.json()
	}

	async createCareer(career) {
		console.log(career)
		const response = await fetch(`${process.env.REACT_APP_API}/career/`, {
			method: 'POST',
			headers: {
				'Content-type': 'application/json',
			},
			body: JSON.stringify(career),
		})

		return await response.json()
	}

	async deleteCareer(id) {
		const response = await fetch(`${process.env.REACT_APP_API}/career/${id}`, {
			method: 'DELETE',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return await response.json()
	}

	//Employee View
	async getAllCareerEmployee(employee_id) {
		const response = await fetch(`${process.env.REACT_APP_API}/career/employee/${employee_id}`, {
			method: 'GET',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return await response.json()
	}
	async addNewCareerEmployee(data) {
		const response = await fetch(`${process.env.REACT_APP_API}/career/`, {
			method: 'POST',
			headers: {
				'Content-type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		return await response.json()
	}
	async updateCareerEmployee(id, data) {
		const response = await fetch(`${process.env.REACT_APP_API}/career/${id}`, {
			method: 'PUT',
			headers: {
				'Content-type': 'application/json',
			},
			body: JSON.stringify(data),
		})

		return await response.json()
	}
	async deleteCareerEmployee(id) {
		const response = await fetch(`${process.env.REACT_APP_API}/career/${id}`, {
			method: 'DELETE',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return await response.json()
	}
}

export default new Career()
